var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4714 4.47157C12.7318 4.21122 12.7318 3.78911 12.4714 3.52876C12.2111 3.26841 11.7889 3.26841 11.5286 3.52876L8 7.05735L4.47141 3.52876C4.21106 3.26841 3.78895 3.26841 3.5286 3.52876C3.26825 3.78911 3.26825 4.21122 3.5286 4.47157L7.05719 8.00016L3.5286 11.5288C3.26825 11.7891 3.26825 12.2112 3.5286 12.4716C3.78895 12.7319 4.21106 12.7319 4.47141 12.4716L8 8.94297L11.5286 12.4716C11.7889 12.7319 12.2111 12.7319 12.4714 12.4716C12.7318 12.2112 12.7318 11.7891 12.4714 11.5288L8.94281 8.00016L12.4714 4.47157Z",
    fill: "#405480"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFile);
export default __webpack_public_path__ + "static/media/RemoveFile.0911c5cc4020f15ac9e147dd5e1e9d95.svg";
export { ForwardRef as ReactComponent };